var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"second-main"},[_c('CommonGridContainer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }